<template>
    <div>
        <!-- stage two of post aNewItem -->
        <div class="container">
            <div class="row my-3">
                <div class="col-4">
                    <div class="progress">
                        <div @click="gotoStage1" class="progress-bar bg-dark-green" role="progessbar" style="width: 100%; cursor: pointer;">1/3</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="progress">
                        <div class="progress-bar bg-dark-green" role="progessbar" style="width: 100%">2/3</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="progress">
                        <div class="progress-bar bg-grey text-dark-green" role="progessbar" style="width: 100%">3/3</div>
                    </div>
                </div>
            </div>
            <!-- Alert Messages -->
            <dl v-if="msg !== ''" class="row mt-3 mb-n3">
                <dd class="col-12">
                    <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                        <i class="fas fa-exclamation-circle"></i> {{ msg }}
                    </div>
                </dd>
            </dl>
            <form>
                <!-- stage heading -->
                <div class="row mt-5">
                    <div class="col-md-7 col-sm-6 col-12">
                        <h3 class="small-text">Item Description</h3>
                    </div>
                    <div class="col-md-5 col-sm-6 col-12">
                        <div class="row">
                            <div class="col-6">
                                <span @click="gotoStage1" class="btn btn-light btn-sm h3 mx-2 form-control">&lt;&lt; Previous</span>
                            </div>
                            <div class="col-6">
                                <button @click.prevent="gotoStage3" class="btn btn-dark-green btn-sm h3 form-control">Next &gt;&gt;</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- preview images -->
                <div class="row my-3">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="form-group">
                                    <label for="itemTitle">Item Title:</label>
                                    <input v-model="title" type="text" class="form-control no-lines" id="itemTitle" placeholder="|">
                                </div>
                                <div class="form-group">
                                    <label for="itemDescription">Item Description:</label>
                                    <textarea v-model="description" type="text" class="form-control no-lines" id="itemDescription" rows="7" placeholder="|"></textarea>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 col-sm-12">
                                        <div class="fom-group">
                                            <label for="itemCategory">Item Category:</label>
                                            <select v-model="category" class="custom-select no-lines" id="itemCategory" style="border-color: #DFDFDF;">
                                                <option selected disabled value="">-select-</option>
                                                <option v-for="(x, i) in theCategories" :key="i" :value="x.category">
                                                    {{x.category}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="fom-group mt-sm-3 mt-md-0">
                                            <label for="itemSubCategory">Item Sub-Category:</label>
                                            <select v-model="subCategory" class="custom-select no-lines" id="itemSubCategory" style="border-color: #DFDFDF;">
                                                <option selected disabled value="">-select-</option>
                                                <option v-for="(x, i) in theSubCategories" :key="i" :value="x.subCategory">
                                                    {{x.subCategory}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="fom-group mt-3">
                                    <label for="itemCategory">Item Condition:</label>
                                    <select v-model="condition" class="custom-select no-lines" id="itemCategory" style="border-color: #DFDFDF;">
                                        <option selected disabled value="">-select-</option>
                                        <option v-for="(x, i) in theConditions" :key="i" :value="x.condition">
                                            {{x.condition}}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group mt-3">
                                    <label for="itemReferenceUrl">Item Ref. URL (optional):</label>
                                    <input v-model="refUrl" type="text" class="form-control no-lines" id="itemReferenceUrl" placeholder="|">
                                </div>
                            </div>
                            <div class="card-footer text-dark-green text-center">
                                <span>Note: Being very descriptive about your item increases its chances of being seen by many potential buyers!</span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <!-- import sub-categories here -->
        <app-sub-categories :categoryName="category"></app-sub-categories>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'
import SubCategories from '@/components/general/shared/ItemParts/SubCategories.vue'

export default {
    name: "StageTwo",
    data() {
        return {
            title: '',
            description: '',
            category: '',
            subCategory: '',
            condition: '',
            refUrl: '',
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['buildNewItemObj']),
        gotoStage1() {
            this.mutateNextStage = true;
            eventBus.gotoStage1(this.mutateNextStage)
        },
        gotoStage3() {
            this.color = "danger"
            if(this.title === ''){ this.msg = "Adding a title makes your item most visible to buyers"; return }
            if(this.description === ''){ this.msg = "Entering a clear description increases your chances of selling sooner"; return }
            if(this.category === ''){ this.msg = "Select any category you think best describes this item"; return }
            if(this.condition === ''){ this.msg = "Select the appropriate condition of this item"; return }
            // add properties to build aNewItem object 
            let newItemObj = {
                title: this.title,
                description: this.description,
                category: this.category,
                subCategory: this.subCategory,
                condition: this.condition,
                refUrl: this.refUrl
            }
            this.buildNewItemObj(newItemObj)
            .then(() => {
                this.mutateNextStage = true;
                eventBus.gotoStage3(this.mutateNextStage)
            })
            .catch((e) => {
                this.msg = "We are unable to proceed with this item at this time, do try again."
            })
        }
    },
    computed: {
        ...mapGetters(['setCategories', 'setSubCategories', 'setConditions', 'anewitem']),
        theCategories(){
            if(this.setCategories && this.setCategories.length){
                return this.setCategories
            }
            return [] 
        },
        theSubCategories(){
            if(this.setSubCategories && this.setSubCategories.length){
                return this.setSubCategories
            }
            return [] 
        },
        theConditions(){
            if(this.setConditions && this.setConditions.length){
                return this.setConditions
            }
            return []
        },
    },
    components: {
        appSubCategories: SubCategories
    },
    created() {
        if(this.anewitem && this.anewitem !== null){
            if(this.anewitem.title){ this.title = this.anewitem.title }
            if(this.anewitem.description){ this.description = this.anewitem.description }
            if(this.anewitem.category){ this.category = this.anewitem.category }
            if(this.anewitem.subCategory){ this.subCategory = this.anewitem.subCategory }
            if(this.anewitem.condition){ this.condition = this.anewitem.condition }
            if(this.anewitem.refUrl){ this.refUrl = this.anewitem.refUrl }
        }
    }
}
</script>